module.exports = __webpack_public_path__ + "img/approval3.9c19a243.png";